if (import.meta.env.MODE === 'FIELD') {
  await import('./main-field.ts');
} else if (import.meta.env.MODE === 'PORTAL') {
  await import('./main-portal.ts');
} else {
  await import('./main-office.ts');
}
